module.exports = __webpack_public_path__ + "static/img/oprCt_bg_08.87801014.svg";